import React__default, { Component } from 'react';
import { __extends, __assign } from '../../_virtual/_tslib.js';
import { ChatContextConsumer } from '../ChatContext/index.js';
import hoistNonReactStatic from 'hoist-non-react-statics';

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

function withChat(WrappedComponent) {
  var WithChat =
  /** @class */
  function (_super) {
    __extends(WithChat, _super);

    function WithChat() {
      return _super !== null && _super.apply(this, arguments) || this;
    }

    WithChat.prototype.render = function () {
      var _this = this;

      return React__default.createElement(ChatContextConsumer, null, function (_a) {
        var client = _a.client,
            customMessageComponents = _a.customMessageComponents,
            authenticatedUserId = _a.authenticatedUserId,
            impersonating = _a.impersonating;
        return React__default.createElement(WrappedComponent, __assign({
          chatClient: client,
          authenticatedUserId: authenticatedUserId,
          customMessageComponents: customMessageComponents,
          impersonating: impersonating
        }, _this.props));
      });
    };

    WithChat.displayName = "WithChat(" + getDisplayName(WrappedComponent) + ")";
    return WithChat;
  }(Component);

  return hoistNonReactStatic(WithChat, WrappedComponent);
}

export default withChat;
//# sourceMappingURL=withChat.js.map
